import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next'

@translate([], {wait: true})
@inject('BetslipStore', 'NewBetslipStore')
@observer
class MbAsiaReuseSelectionComponent extends Component {

  constructor(props) {
    super(props);
  }

  handleReuseSelection() {
    this.props.BetslipStore.updateIsReuseSelection(true);
    this.props.BetslipStore.updateBetslipReadyState(false);
    this.props.BetslipStore.displayAsiaBetslip(true);

    if (this.props.isToast) {
      this.props.closeToast();
    }
  }

    render() {
        return (
            <div className='reuseSelection_container'>
                <a className='reuse-selection' onClick={this.handleReuseSelection.bind(this)}>{this.props.t('Reuse selection')}</a>
            </div>
        )
    }
}
export default MbAsiaReuseSelectionComponent;


// WEBPACK FOOTER //
// ./src/app/components/BetslipComponent/AsiaView/MbAsiaReuseSelectionComponent/index.js